import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addTransaction, deleteTransaction, editTransaction, getBalance, getTransactions } from "./transactionAPI";

//define initial state
const initialState = {
  transactions: [],
  totalTransactions: 0,
  loading: {
    loadingType: "",
    isLoading: false,
  },
  error: {
    isError: false,
    errorMsg: "",
    errorType: "",
  },

  editing: {},
  totalBalance: 0,
};

//async thunks
export const fetchTransactions = createAsyncThunk("transaction/fetchTransactions", async (filter) => {
  const transactions = await getTransactions(filter);
  return transactions;
});

export const fetchBalance = createAsyncThunk("transaction/fetchBalance", async () => {
  const transactions = await getBalance();
  return transactions;
});

export const createTransaction = createAsyncThunk("transaction/createTransaction", async (data) => {
  const transaction = await addTransaction(data);
  return transaction;
});

export const updateTransaction = createAsyncThunk("transaction/updateTransaction", async ({ id, data }) => {
  const transaction = await editTransaction(id, data);
  return transaction;
});
export const removeTransaction = createAsyncThunk("transaction/removeTransaction", async (id) => {
  const transaction = await deleteTransaction(id);
  return transaction;
});

//create slice

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    editActive: (state, action) => {
      state.editing = action.payload;
    },
    editInactive: (state) => {
      state.editing = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.pending, (state) => {
        state.transactions = [];
        state.loading.isLoading = true;
        state.loading.loadingType = "fetchTransactions";
        state.error.isError = false;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading.isLoading = false;
        state.loading.loadingType = "";
        state.error.isError = false;

        state.transactions = action.payload.data;
        state.totalTransactions = action.payload.totalData;
      })

      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading.isLoading = false;
        state.error.isError = true;
        state.error.errorMsg = action.error.message;
        state.error.errorType = "fetchError";
        state.transactions = [];
      })

      //get balance
      .addCase(fetchBalance.pending, (state) => {
        state.loading.isLoading = true;
        state.loading.loadingType = "fetchBalance";
        state.error.isError = false;
      })
      .addCase(fetchBalance.fulfilled, (state, action) => {
        state.loading.isLoading = false;
        state.loading.loadingType = "";
        state.error.isError = false;
        state.totalBalance = action.payload.reduce((total, current) => {
          if (current.type === "income") {
            return total + Number(current.amount);
          } else {
            return total - Number(current.amount);
          }
        }, 0);
      })

      .addCase(fetchBalance.rejected, (state, action) => {
        state.loading.isLoading = false;
        state.error.isError = true;
        state.loading.loadingType = "";
        state.error.errorMsg = action.error.message;
        state.error.errorType = "balanceError";
        state.totalBalance = 0;
      })

      // add transaction to database
      .addCase(createTransaction.pending, (state) => {
        state.loading.isLoading = true;
        state.loading.loadingType = "createTransaction";
        state.error.isError = false;
      })
      .addCase(createTransaction.fulfilled, (state, action) => {
        state.loading.isLoading = false;
        state.loading.loadingType = "";
        state.error.isError = false;
        state.transactions.unshift(action.payload);
        if (state.transactions.length > 5) {
          state.transactions.pop();
        }
      })

      .addCase(createTransaction.rejected, (state, action) => {
        state.loading.isLoading = false;
        state.error.isError = true;
        state.loading.loadingType = "";
        state.error.errorMsg = action.error?.message;
        state.error.errorType = "createError";
      })

      //edit Transaction
      .addCase(updateTransaction.pending, (state) => {
        state.loading.isLoading = true;
        state.loading.loadingType = "updateTransaction";
        state.error.isError = false;
      })
      .addCase(updateTransaction.fulfilled, (state, action) => {
        state.loading.isLoading = false;
        state.loading.loadingType = "";
        state.error.isError = false;
        const indexToUpdate = state.transactions.findIndex((t) => t.id === action.payload.id);
        state.transactions[indexToUpdate] = action.payload;
      })

      .addCase(updateTransaction.rejected, (state, action) => {
        state.loading.isLoading = false;
        state.loading.loadingType = "";
        state.error.isError = true;
        state.error.errorMsg = action.error?.message;
        state.error.errorType = "updateError";
      })

      //   delete a transaction
      .addCase(removeTransaction.pending, (state) => {
        state.loading.isLoading = true;
        state.loading.loadingType = "removeTransaction";
        state.error.isError = false;
      })
      .addCase(removeTransaction.fulfilled, (state, action) => {
        state.loading.isLoading = false;
        state.loading.loadingType = "";
        state.error.isError = false;
        state.transactions = state.transactions.filter((t) => t.id !== action.payload);
      })

      .addCase(removeTransaction.rejected, (state, action) => {
        state.loading.isLoading = false;
        state.error.isError = true;
        state.error.errorMsg = action.error?.message;
        state.error.errorType = "removeError";
      });
  },
});

export default transactionSlice.reducer;
export const { calculateBalance, editActive, editInactive } = transactionSlice.actions;
